import SystemBannerMessage from 'src/Components/Admin/System/SystemBannerMessage';

const SystemAdminPage = () => {

  return (
    <SystemBannerMessage />
  );
};
export default SystemAdminPage;